import React from 'react';
import { ModalContainer } from '../../../../../../shared/modal-container/ModalContainer';
import { addUserToTeam } from '../../redux/update-user/actions';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { AddUserToTeamModalContent } from './AddUserToTeamModalContent';
import { EditTeamModalContent } from '../../../teams/team-details/edit-team/EditTeamModalContent';
import { editTeam } from '../../../teams/redux/edit-team/actions';
import { TeamDetailsModalMode } from '../../../teams/team-details/TeamDetails';

const handleAddUserToTeam = (props, user) => {
    _.isFunction(props.addUserToTeam) &&
        props.addUserToTeam(user.id, props.team.id);
    _.isFunction(props.forwardedRef.current.closeModal) &&
        props.forwardedRef.current.closeModal();
};

const handleEditTeam = (props, teamDetails) => {
    const { team, editTeam } = props;
    const { name, description } = teamDetails;

    team &&
        _.isFunction(editTeam) &&
        editTeam(team.id, {
            name: name || team.name,
            description: description || team.description
        });
    _.isFunction(props.forwardedRef.current.closeModal) &&
        props.forwardedRef.current.closeModal();
};

const getTeamFilteredUsers = props => {
    // Get only users that don't belong to the current team.
    const { users, team } = props;

    return (users || []).filter(
        user => !user.belongsInTeams.find(userTeam => userTeam.id === team.id)
    );
};

const AddUserEditTeamModal = props =>
    props.mode === TeamDetailsModalMode.ADD ? (
        <ModalContainer
            content={
                <AddUserToTeamModalContent
                    users={getTeamFilteredUsers(props)}
                    addUserToTeam={user => handleAddUserToTeam(props, user)}
                />
            }
            title={'Add User To Team'}
            ref={props.forwardedRef}
        />
    ) : (
        <ModalContainer
            content={
                <EditTeamModalContent
                    team={props.team}
                    editTeam={teamDetails => handleEditTeam(props, teamDetails)}
                />
            }
            title={'Edit Team'}
            ref={props.forwardedRef}
        />
    );

const mapDispatchToProps = dispatch => ({
    addUserToTeam: (userId, teamId) =>
        dispatch(addUserToTeam({ userId, teamId })),
    editTeam: (teamId, teamDetails) =>
        dispatch(editTeam({ teamId, teamDetails }))
});

const ConnectedAddUserEditTeamModal = connect(
    null,
    mapDispatchToProps
)(AddUserEditTeamModal);

export default React.forwardRef((props, ref) => (
    <ConnectedAddUserEditTeamModal {...props} forwardedRef={ref} />
));
